import Enum from "../../../../../../enums/Enum";

const PatientInformedEnum = new Enum({
    CALENDAR: {name: "Calendar"},
    EMAIL: {name: "E-mail"},
    TELEPHONE: {name: "Telephone"}
});

export default PatientInformedEnum;